﻿
function like(event) {
    event.preventDefault();
    var articleId = $(this).data("article-like");
    if (articleId !== "") {
        $.get('/article-like/handle/',
            { articleId : articleId }
            , function (response) {
                if (response != "error") {
                    $("[data-article-like-text]").html(response);
                }
            });
    }
}
export function setupArticleLike(){
    $(document).on("click", "[data-article-like]", like);

}